import { useLayoutEffect, useRef } from 'react';
import './SplashScreen.scss';

const SplashScreen = (): JSX.Element => {
    const textRef = useRef<HTMLHeadingElement>(null);

    useLayoutEffect(() => {
        const text = textRef.current!;
        text.innerHTML = text.textContent!.replace(/\S/g, "<span class='letter'>$&</span>");

        const textLetters = document.querySelectorAll<HTMLElement>('h3 .letter');
        textLetters.forEach((e, i) => {
            const delay = 500 * (i / textLetters.length);
            e.style.animationDelay = `${800 + delay}ms, ${2000 + delay}ms`;
        });
    });

    return (
        <div id="splash-screen">
            <div className="main-text">
                <div className="opening-slash">/</div>
                <h3 ref={textRef}>Pranav Pakanati</h3>
                <p>Do it with passion, or not at all.</p>
            </div>
        </div>
    );
}

export default SplashScreen;